import React from "react";
import {UserModuleManageAccountsInfo} from "./UserModuleManageAccountsInfo";
import {UserContentBase} from "./UserContentBase";


export class UserModuleManageAccountsContent extends UserContentBase {
    render() {
        return (
            <section className="section-content">
                {this.renderHeaderAndTabs("fourth")}
                <div className="section-body h-items">
                    <UserModuleManageAccountsInfo
                        userId={this.props.userId}
                        afterSuccessfulSubmit={this.handleAfterSuccessfulUserUpdated}
                    />
                </div>
            </section>
        )
    }
}
